export const SET_FRONT_LIGHT_STATE = "SET_FRONT_LIGHT_STATE";
export const SET_BACK_LIGHT_STATE = "SET_BACK_LIGHT_STATE";
export const SET_CABIN_LIGHT_STATE = "SET_CABIN_LIGHT_STATE";
export const SET_WAGON_LIGHT_STATE = "SET_WAGON_LIGHT_STATE";
